import Imatge from 'components/corporatiu/Imatge';
import Icona from 'components/corporatiu/Icona';
import Enllac from 'components/corporatiu/Enllac';
import BotoSubscripcio from 'components/corporatiu/Butlletins/BotoSubscripcio';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './destacatbutlleti.module.scss';

const Periodicitat = (props) => {
    const periodicitat = props.periodicitat?.find((p) => p.main)?.desc;

    if (__isEmpty(periodicitat)) return <></>;
    return (
        <div className={styles.periodicitat}>
            <Icona className={styles.iconaCalendari} icona='calendari' isBlanc={false} inline={true} />
            <span className={styles.freq}>{periodicitat}</span>
        </div>
    );
};

const DestacatButlleti = (props) => {
    const { item, className, estil } = props;
    const { titol, entradeta, periodicitat, id, imatges } = item;
    const route = {
        type: 'web_butlletins_item_butlleti',
        slug: titol,
        id
    };

    const stylesButlleti = clsx({
        [styles.butlleti]: true,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    return (
        <div className={stylesButlleti}>
            <section className={styles.cos}>
                <Enllac route={route}>
                    <div className={styles.blocImgText}>
                        {imatges && (
                            <div className={styles.imatgeWrapper}>
                                <Imatge
                                    className={styles.imatge}
                                    imatges={imatges}
                                    tipus='web_poster_horitzontal'
                                    layout='fill'
                                    alt={titol}
                                    aria-hidden='true'
                                    objectFit='cover'
                                />
                            </div>
                        )}
                        <div className={styles.info}>
                            <h3 className={styles.titol}>{titol}</h3>
                            <p className={styles.desc}>{entradeta}</p>
                            <Periodicitat periodicitat={periodicitat} />
                        </div>
                    </div>
                </Enllac>
                <div className={styles.contentBoto}>
                    <BotoSubscripcio id={id} titol={titol} />
                </div>
            </section>
        </div>
    );
};

export default DestacatButlleti;
